import api from "../utils/axios";

export const rolesAPI = {
  // Create a new role
  createRole: async (roleData) => {
    const response = await api.post("/roles", roleData);
    return response.data;
  },

  // Get all roles
  getRoles: async () => {
    const response = await api.get("/roles");
    return response.data;
  },

  // Get a specific role by ID
  getRole: async (roleId) => {
    const response = await api.get(`/roles/${roleId}`);
    return response.data;
  },

  // Update a role
  updateRole: async (roleId, roleData) => {
    const response = await api.put(`/roles/${roleId}`, roleData);
    return response.data;
  },

  // Delete a role
  deleteRole: async (roleId) => {
    const response = await api.delete(`/roles/${roleId}`);
    return response.data;
  },
};
